// --------------------------------------------------------------------------
// #201 Membership Lookup
// --------------------------------------------------------------------------
// Author:      Alix Richards
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2016, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var reinitModules = require('../utilities/reinit-modules');

// jquery plugins
require('../plugins/jquery.validate.hooks');
require('../plugins/jquery.validate');
require('../plugins/jquery.validate.unobtrusive');

module.exports = function (options) {
    var context = options.context;
    var checkForm = false;
    var formValid = false;
    var wrapper = context.find('[data-name="membership-lookup-form-wrapper"]');

    /// Init function from app.js
    function reinitialiseModules() {
        var modules = [{
            name: 'hotspot',
            module: require('../modules/in-text-hotspot')
        }];
        reinitModules(modules);
    }

    function lookupRenewalDetails(lookupForm) {
        $.ajax({
            data: lookupForm.serialize() + '&' + 'Lookup=',
            type: lookupForm.attr('method'),
            url: lookupForm.attr('action'),
            success: function success(data, textStatus, xhr) {
                var $data = $(data);
                var dataError = $data.find('.validation-summary-errors');

                if ($data.length) {
                    wrapper.empty().append($data);

                    if (dataError.length) {
                        /// If there are errors we need to re-bind and re-initialise
                        reinitialiseModules();
                        bindings();
                    }
                } else {
                    if (xhr.status > 200) {
                        context.find('[data-binding="membership-lookup"]').append('<div class="validation-summary"><div class="validation-summary-errors" data-valmsg-summary="true"><h3>There was a problem with our lookup system:</h3><ul><li>We couldn’t find an annual membership due to our memership lookup system’s failure. Please try again later.</ul></div>');
                    }
                }
            },
            error: function error() {
                context.find('[data-binding="membership-lookup"]').append('<div class="validation-summary"><div class="validation-summary-errors" data-valmsg-summary="true"><h3>There was a problem with our lookup system:</h3><ul><li>We couldn’t find an annual membership due to our memership lookup system’s failure. Please try again later.</ul></div>');
            }
        });
    }

    function checkIfWeShouldDoSomeAjax(lookupForm) {
        if (formValid) {
            lookupRenewalDetails(lookupForm);
        }
    }

    function isFormValid(lookupForm) {
        var inputError = context.find('.input-validation-error').length;
        var errorCount = parseInt(inputError);

        if (errorCount === 0) {
            formValid = true;
            checkIfWeShouldDoSomeAjax(lookupForm);
        }
    }

    function bindings() {
        var lookupForm = context.find('form');
        /// jQuery Validate Hooks: https://gist.github.com/remi/957732
        /// running this overrides some jQuery Validate stuff so we can hook into its validations.
        /// triggerElementValidationsOnFormValidation is optional and will fire off all of your
        /// element validations WHEN the form validation runs ... it requires jquery.validate.unobtrusive
        lookupForm.addTriggersToJqueryValidate().triggerElementValidationsOnFormValidation();
        /// You can bind to events that the forms/elements trigger on validation
        lookupForm.bind('formValidation', function () {
            checkForm = true;
        });

        lookupForm.on('submit', function (e) {
            e.preventDefault();

            if (checkForm) {
                isFormValid(lookupForm);
            }
        });

        // remove jQuery validation for the postcode
        delete $.data(lookupForm[0], 'validator').settings.rules['ContactLookupModel.Postcode'];
    }

    function init() {
        /**
         * As with form-toggle.js,
         * we need to wait until the document is 'ready', as this behavior may be
         * initialised before jQuery.validate(), making the latter undefined if used
         */
        $(document).ready(function () {
            bindings();
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/membership-lookup.js
// module id = 268
// module chunks = 0